import React, {useEffect, useState} from "react";
import {
    Box,
    Container,
    Grid,
    Paper,

} from "@mui/material";
import MainLayout from "../MainLoyout/MainLayout";
import Api from "../../Services/Api";
import {DataGrid, GridActionsCellItem} from '@mui/x-data-grid';
import Skeleton from "@mui/material/Skeleton";

import Title from "../Title";
import {ContentCopy} from "@mui/icons-material";

import {Circle} from "@mui/icons-material";

const SupplyFeeds = () => {


    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = useState(false);
    const [supplyFeeds, setSupplyFeeds] = useState([]);
    const [suppliers, setSuppliers] = useState([]);





    useEffect(() => {

        loadData()
    }, []);

    const loadData = async () => {
        setLoading(true)
        await Api.supply().then(r => setSupplyFeeds(r))
        await Api.supplyPartners().then(r => setSuppliers(r))

        setLoading(false)
    }

    const handleRefresh = () => {
        loadData()
    }

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );


    const columns = [

        {
            field: "active",
            headerName: "",
            minWidth: 50,
            type: 'number',
            editable: false,
            flex: 0.2,
            renderCell: (params) => params.row.active ? <Circle color={"success"}/> : <Circle color={"error"}/>
        },
        {
            field: "id",
            headerName: "Id",
            type: 'number',
            editable: false,
            minWidth: 50,
            flex: 0.2,

        },
        {
            field: "user_id",
            headerName: "User Id",
            type: 'number',
            editable: false,
            minWidth: 50,
            flex: 0.4,
            hide: true,


        },
        {
            field: "name",
            headerName: "Name",
            minWidth: 200,
            type: 'text',
            editable: false,
            flex: 0.4


        },

        {
            field: "tracking_url",
            headerName: "Tracking Link",
            minWidth: 500,
            type: 'text',
            editable: false,
            flex: 1,
            valueGetter: (params) => "https://"+params.row?.domain?.domain+"/track/" + params.row?.id + "/?q={keyword}&sub_id={sub_id}"
        },
        // {
        //     field: "capping_%",
        //     headerName: "Cap %",
        //     renderCell: renderProgress,
        //     minWidth: 100,
        //     type: 'number',
        //     editable: false,
        //     flex: 0.2,
        //     valueGetter: (params) => (params.row?.supply_stats?.length ? Math.max(...params.row?.supply_stats?.map(o => o.searches)) / params.row?.capping : 0)
        // },
        {
            field: "capping",
            headerName: "Cap",
            minWidth: 100,
            type: 'number',
            editable: false,
            flex: 0.2,

        },

        {
            headerName: "Actions",
            field: 'actions',
            type: 'actions',
            flex: 0.4,
            width: 100,
            getActions: (params) => ([


                <GridActionsCellItem icon={<ContentCopy/>} onClick={() => {
                    navigator.clipboard.writeText("https://"+params.row?.domain.domain+"/track/"+params.row?.id+"/?q={keyword}&sub_id={sub_id}").then(() => alert('Tracking Link Copied'));
                }} label="Copy Tracking Link"/>


            ])
        }
    ];




    return (
        <MainLayout>

            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={3}>

                    <Grid item xs={12}>
                        <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>
                            <Title>Supply Feeds</Title>

                                    <DataGrid

                                        rows={!loading ? supplyFeeds:[]}
                                        columns={columns}
                                        pageSize={50}
                                        //autoHeight={true}
                                        filterModel={
                                            (user ? {
                                                items: [{columnField: 'user_id', operatorValue: '=', value: user}],
                                            } : {items: []})}


                                        disableSelectionOnClick
                                        disableColumnSelector
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                            height: '600px'
                                        }}
                                        density={"compact"}
                                        components={{
                                            LoadingOverlay: LoadingSkeleton,
                                        }}
                                        loading={loading}
                                    />

                        </Paper>
                    </Grid>
                </Grid>


            </Container>


        </MainLayout>

    )
}


export default SupplyFeeds